import Image from 'next/image';
import './styles.css';

type Props = {
  handleClick: () => void;
  member: {
    name: string;
    position: string;
    srcSet: string;
    description: string;
  };
  showTranslation: string;
};

export default function TeamListItem({
  handleClick,
  member,
  showTranslation,
}: Props) {
  return (
    <div
      onClick={handleClick}
      className="bg-white shadow-[0_10px_20px_0_rgba(0,0,0,0.1)] inline-block overflow-hidden relative w-4/5 lg:mb-[30px] desktop:w-full desktop:hover:shadow-[0_20px_40px_0_rgba(0,0,0,0.3)] desktop:hover:translate-y-[-3%] desktop:transition-all desktop:duration-300 desktop:ease-in-out group cursor-pointer">
      <div className="relative w-full before:pt-[112%] before:content-[''] before:block before:w-full">
        <Image
          src={member.srcSet}
          alt={`${member.name} - ${member.position}`}
          fill
          className="h-full left-0 object-cover absolute top-0 w-full align-middle max-w-full desktop:transition-all desktop:duration-300 desktop:ease-in-out desktop:group-hover:scale-110"
          sizes="(min-width: 1280px) 80vw, (min-width: 767px) 90vw, (min-width: 480px) 100vw, 100vw"
          style={{
            objectFit: 'cover',
          }}
        />
      </div>
      <div className="list-item absolute bottom-0 left-0 p-[20px] w-full text-left transition-[height] duration-300 ease-in-out before:absolute before:left-0 before:bottom-0 before:content-[''] before:h-[100%] before:text-left before:w-full desktop:before:group-hover:h-[200%]">
        <h3 className="text-white text-xl font-semibold relative mb-2 leading-[1.25] mt-0">
          {member.name}
        </h3>
        <div className="text-white text-base relative">{member.position}</div>
        <div className="relative text-sm font-semibold show-card max-h-[270px] overflow-hidden text-white opacity-0 mt-0 uppercase hidden desktop:block desktop:group-hover:mt-[20px] desktop:group-hover:max-h-[420px] desktop:group-hover:opacity-100 desktop:transition-all desktop:duration-300 desktop:ease-in-out">
          {showTranslation}
        </div>
      </div>
    </div>
  );
}
